
import React, { useState, useReducer } from "react";
import { FormControl, InputLabel } from "@material-ui/core";
import produce from "immer";
import ScatterPlot from "./ScatterPlot";
import "./common/Chart.css";
import { useChartDimensions, getGraphDataPerChannel } from "./common/utils";
import GraphSelect from "../GraphSelect";
import { Channels } from "../../constants/graphTypes";
import { graphReducer } from "../../../reducers/graphReducer";

// Declare metrics/accessors

const fields = {

    type: {
        accessor: (d) => d.type,
        title: "Channel Number",
        formatter: (d) => d
    },

    x: {
        accessor: (d) => d.x,
        title: "x Axis", // retrieved from channel
        formatter: (d) => d
    },

    y: {
        accessor: (d) => d.y,
        title: "Y Axis", // retrived from channel
        formatter: (d) => d
    },

    cluster: {
        accessor: (d) => d.cluster_id,
        title: "Cluster id",
        formatter: (d) => d
    }

}

const initialState = {

    xChannel: "Ch2",
    yChannel: "Ch1",
    channelData: null
}
const curryiedGraphReducer = produce(graphReducer);

const Amplitude2D = ({ graphData, activeChannels }) => {

    // TODO : get the data here vs being passed via prop

    // Read from predefined metric(fields)
    const xField = fields.x;
    const yField = fields.y;

    const { accessor: xAccessor, title: xTitle, formatter: xFormatter } = xField;
    const { accessor: yAccessor, title: yTitle, formatter: yFormatter } = yField;

    const ref = React.useRef(null);

    const { width, height } = useChartDimensions(ref);

    const [mapValue, setMapValue] = useState("scatter");

    const visibleChannels = activeChannels
        ? Channels.filter(c => activeChannels.includes(c.name))
        : Channels;
    const defaultX = visibleChannels[1]?.name ?? visibleChannels[0]?.name ?? "Ch2";
    const defaultY = visibleChannels[0]?.name ?? "Ch1";

    const initalizeStateLazily = () => (
        {
            xChannel: defaultX,
            yChannel: defaultY,
            channelData: getGraphDataPerChannel(graphData, defaultX, defaultY)
        }
    );

    const [state, dispatch] = useReducer(curryiedGraphReducer, initialState, initalizeStateLazily);

    const { xChannel, yChannel, channelData } = state;

    const handleMapToggle = (e) => {
        setMapValue(e.target.value);
    };

    const handleSelectedXChannel = (e) => {
        const chData = getGraphDataPerChannel(graphData, e.target.value, yChannel);
        dispatch({ type: e.target.value, payload: chData, xChannel: e.target.value, yChannel: yChannel });
    }

    const handleSelectedYChannel = (e) => {
        const chData = getGraphDataPerChannel(graphData, xChannel, e.target.value);
        dispatch({ type: e.target.value, payload: chData, yChannel: e.target.value, xChannel: xChannel });
    }
    return (<>

        <div id="channels">
            <FormControl variant="standard" sx={{ m: 1, minWidth: 240 }}>
                <InputLabel id="demo-simple-select-standard-label">
                    X
                </InputLabel>

                <GraphSelect
                    graph={visibleChannels}
                    defaultValue={xChannel}
                    onSelect={handleSelectedXChannel}

                />
            </FormControl>

            <div></div>

            <FormControl variant="standard" sx={{ m: 1, minWidth: 240 }}>
                <InputLabel id="demo-simple-select-standard-label">
                    Y
                </InputLabel>

                <GraphSelect
                    graph={visibleChannels}
                    defaultValue={yChannel}
                    onSelect={handleSelectedYChannel}

                />
            </FormControl>

        </div>

        <div id="controls">
            <button className={`button ${mapValue === "scatter" ? 'current' : " "}`} value="scatter" onClick={handleMapToggle}>Scatter</button>
            <button className={`button ${mapValue === "heat" ? 'current' : ""}`} value="heat"
                style={{ marginLeft: 10 }} onClick={handleMapToggle}>Heat</button>
        </div>

        <div
            className="graphborder graphborder-dashed border-cyan-500"
            ref={ref}
            style={{ height: 450 }}>

            <ScatterPlot
                width={width}
                height={height}
                data={channelData}
                xAccessor={xAccessor}
                yAccessor={yAccessor}
                xLabel={xChannel}
                yLabel={yChannel}
                xFormatter={xFormatter}
                yFromatter={yFormatter}
                map={mapValue}
                graphType={'2D'}
            />

        </div>

    </>);
}

export default Amplitude2D;














// old working code before adding channel flips



// import React, { useState } from "react";
// import ScatterPlot from "./ScatterPlot";
// import { format } from "d3-format";
// import "./common/Chart.css";
// import { useChartDimensions } from "./common/utils";
// import * as vega from "vega";
// import * as vegaLite from 'vega-lite';
// import * as vl from "vega-lite-api";
// import { Handler } from "vega-tooltip";
// import { config } from "./config";

// import * as d3 from "d3";
// // Declare metrics/accessors

// const fields = {
//     ch1amp: {
//         accessor: (d) => d.Ch1_amp,
//         title: "Ch1 Amp",
//         formatter: (d) => d
//     },
//     ch2amp: {
//         accessor: (d) => d.Ch2_amp,
//         title: "Ch2 Amp",
//         formatter: (d) => d
//     },
//     ch3amp: {
//         accessor: (d) => d.Ch3_amp,
//         title: "Ch3 Amp",
//         formatter: (d) => d
//     },
//     ch4amp: {
//         accessor: (d) => d.Ch4_amp,
//         title: "Ch4 Amp",
//         formatter: (d) => d
//     },
//     ch5amp: {
//         accessor: (d) => d.Ch5_amp,
//         title: "Ch5 Amp",
//         formatter: (d) => d
//     },

//     ch6amp: {
//         accessor: (d) => d.Ch6_amp,
//         title: "Ch6 Amp",
//         formatter: (d) => d
//     },

//     count: {
//         accessor: (d) => d.cluster_id,
//         title: "Cluster",
//         formatter: (d) => d
//     }

// }

// const Amplitude2D = (graphData) => {

//     // TODO : get the data here vs being passed via prop

//     // Read from predefined metric(fields)
//     const xField = fields.ch1amp;
//     const yField = fields.ch2amp;
//     const colorField = fields.count;
//     const rField = fields.count;

//     const { accessor: xAccessor, title: xTitle, formatter: xFormatter } = xField;
//     const { accessor: yAccessor, title: yTitle, formatter: yFormatter } = yField;
//     const { accessor: rAccessor } = rField;
//     const { accessor: colorAccessor } = colorField;

//     const ref = React.useRef(null);

//     const { width, height } = useChartDimensions(ref);

//     const [mapValue, setMapValue] = useState("scatter");

//     const handleMapToggle = (e) => {
//         setMapValue(e.target.value);
//     };

//     return (<>
//         <div id="controls">
//             <button className={`button ${mapValue === "scatter" ? 'current' : " "}`} value="scatter" onClick={handleMapToggle}>Scatter</button>
//             <button className={`button ${mapValue === "heat" ? 'current' : ""}`} value="heat"
//                 style={{ marginLeft: 10 }} onClick={handleMapToggle}>Heat</button>
//         </div>

//         <div
//             className="graphborder graphborder-dashed border-cyan-500"
//             ref={ref}
//             style={{ height: 450 }}>

//             <ScatterPlot
//                 width={width}
//                 height={height}
//                 data={graphData.graphData} //graphData.graphData
//                 xAccessor={xAccessor}
//                 yAccessor={yAccessor}
//                 //     rAccessor={rAccessor}
//                 //     colorAccessor={colorAccessor}
//                 xLabel={xTitle}
//                 yLabel={yTitle}
//                 xFormatter={xFormatter}
//                 yFromatter={yFormatter}
//                 map={mapValue}
//                 graphType={'2D'}
//             />

//         </div>

//     </>);
// }

// export default Amplitude2D;


// old vega-lite code

// import React, { useEffect, useRef } from "react";
// import * as vega from "vega";
// import * as vegaLite from 'vega-lite';
// import * as vl from "vega-lite-api";
// import { Handler } from "vega-tooltip";
// import { config } from "./config";

// //import { d3 } from "d3";
// import { makeStyles } from "@material-ui/core/styles";


// const useStyles = makeStyles((theme) => ({}));
// const Amplitude2D = (graphData) => {
//     const chartRef = useRef(null);
//     vl.register(vega, vegaLite, {
//         view: { renderer: 'canvas' },
//         init: view => { view.tooltip(new Handler().call); }
//     });

//     console.log(window.innerHeight);
//     console.log(window.innerWidth);

//     useEffect(() => {
//         vl
//             .markBar({
//                 tooltip: { content: graphData.graphData },
//                 //  size: 100,
//                 // opacity: 0.2,
//             })
//             .data(graphData.graphData)
//             .params(vl.selectInterval().bind("scales"))
//             .encode(
//                 vl.x().fieldQ("Ch2_amp").bin({ maxbins: 60, step: 100 }).title("Ch2 Amp"),
//                 vl
//                     .y()
//                     .fieldQ("Ch1_amp")
//                     .bin({ maxbins: 60, step: 100 }).title("Ch1 Amp")
//                     .axis({ minExtent: 30 }),
//                 //vl.size().count(),
//                 vl.color().bin,
//                 vl
//                     .color()
//                     .fieldO('cluster_id')
//                     .scale({
//                         domain: ['1', '2', '3', '4'],
//                         range: [
//                             'rgb(76,120,168)',
//                             'rgb(84,162,75)',
//                             'rgb(228,87,86)',
//                             'rgb(121,112,110)'
//                         ]
//                     }),

//             )
//             .width(900)
//             .height(800)
//             .autosize({ type: 'fit', contains: 'padding' })
//             .config(config)
//             .render()
//             .then(chart => {
//                 const node = chartRef.current;
//                 if (node.firstChild) {
//                     node.removeChild(node.firstChild);
//                 }
//                 node.appendChild(chart);
//             });
//         // no need of a clean up function when component is unmounted React will automatically remove the DOM nodes that are children of the ref..

//         //return () => { chartRef.current.reset() };

//     }, [graphData.graphData])

//     return (<> <div ref={chartRef}></div> </>);
// }

// export default Amplitude2D;
